module.exports = __webpack_public_path__ + "img/produkterdkSIK_Krone_DARK.4e8e3571.svg";